import {
  Paper as MuiPaper,
  styled,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { spacing } from "@mui/system";
import { useState } from "react";

import LogoSection from "../../../../components/logoSection/LogoSection";
import { useUserContext } from "../../../../contexts/UserContext";
import Login from "../login/Login";
import Otp from "../otp/Otp";

const Paper = styled(MuiPaper)(spacing);

const LoginBox = () => {
  const { user } = useUserContext();
  const theme = useTheme();
  const isLgUp = useMediaQuery(theme.breakpoints.up("lg"));
  const { otpResponse } = user;

  const [usedEmail, setUsedEmail] = useState<string>("");

  const renderContent = () => {
    if (!otpResponse)
      return <Login setUsedEmail={(email: string) => setUsedEmail(email)} />;

    return <Otp usedEmail={usedEmail} />;
  };

  return (
    <Paper className="login-screen main-content-homeScreen" p={isLgUp ? 12 : 5}>
      <div className="login">
        <div className="login-box"> {renderContent()}</div>
      </div>
      <LogoSection variant="arvato" />
    </Paper>
  );
};

export default LoginBox;
